import { useMutation } from '@tanstack/react-query'
import { getContent } from '../index'

const useGetContent = () =>
  useMutation({
    mutationFn: getContent,
  })

export default useGetContent
